import Cookies from "js-cookie";

export const setAccessToken = (value: string) => {
  // Store in both localStorage and cookies for KitKat 4.4 compatibility
  try {
    localStorage.setItem("access_token", value);
  } catch (error) {
    console.warn("localStorage not available for access_token:", error);
  }
  Cookies.set("access_token", value, { path: "/" });
};

export const setAuthToken = (value: string) => {
  try {
    localStorage.setItem("auth_token", value);
  } catch (error) {
    console.warn("localStorage not available for auth_token:", error);
  }
  Cookies.set("auth_token", value, { path: "/" });
};

export const clearTokens = () => {
  // Clear from both localStorage and cookies
  try {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
  } catch (error) {
    console.warn("localStorage not available for clearing:", error);
  }

  Cookies.remove("auth_token", { path: "/" });
  Cookies.remove("access_token", { path: "/" });
  Cookies.remove("user_id", { path: "/" });
};

export const getUserId = (): string | undefined => {
  // Try localStorage first
  try {
    const userId = localStorage.getItem("user_id");
    if (userId) return userId;
  } catch (error) {
    console.warn("localStorage not available for user_id:", error);
  }

  return Cookies.get("user_id");
};

export const storeUserId = (value: string) => {
  try {
    localStorage.setItem("user_id", value);
  } catch (error) {
    console.warn("localStorage not available for storing user_id:", error);
  }
  Cookies.set("user_id", value, { path: "/" });
};
